export const advertClientTypeOptions = [
  { value: 'ALL', label: '全部平台' },
  { value: 'HARMONY', label: '鸿蒙元服务' },
  { value: 'WECHAT_MINA', label: '微信小程序' },
  { value: 'APP', label: 'App' },
  { value: 'H5', label: 'H5' }
]

export const advertPositionTypeOptions = [
  { value: 'ALL', label: '全部位置' },
  { value: 'HOME_BANNER', label: '首页轮播' },
  { value: 'SPLASH', label: '开屏' },
  { value: 'WATERFALL', label: '瀑布流' },
  { value: 'POPUP', label: '弹窗' },
  { value: 'MALL_BANNER', label: '商城轮播' }
]

export function validateAdvertPageUrl(form, callback) {
  const pageUrl = String(form.pageUrl || '').trim()
  if (form.advertType === '3') {
    callback()
    return
  }
  if (!pageUrl) {
    callback(new Error('请选择跳转类型后填写跳转路径'))
    return
  }
  if (form.advertType === '1' && !pageUrl.startsWith('/pages/')) {
    callback(new Error('站内路径必须以 /pages/ 开头'))
    return
  }
  if (form.advertType === '2' && !/^https?:\/\//i.test(pageUrl)) {
    callback(new Error('站外链接必须以 http:// 或 https:// 开头'))
    return
  }
  if (pageUrl.length > 200) {
    callback(new Error('跳转路径不能超过 200 个字符'))
    return
  }
  callback()
}

export function validateAdvertEndTime(form, callback) {
  if (form.startTime && form.endTime && form.endTime <= form.startTime) {
    callback(new Error('结束时间必须晚于开始时间'))
    return
  }
  callback()
}

export function validateAdvertPhotos(form, callback) {
  if (form.viewType === '8888' && (!Array.isArray(form.photos) || form.photos.length === 0)) {
    callback(new Error('请上传轮播图片'))
    return
  }
  callback()
}

export function validateAdvertSeq(value, callback) {
  if (!/^[1-9]\d*$/.test(String(value || ''))) {
    callback(new Error('播放顺序必须为大于 0 的整数'))
    return
  }
  callback()
}
